"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Tag = exports.Tags = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Tags = _styled.default.ul(function () {
  return {
    margin: 0,
    padding: 0,
    listStyle: 'none'
  };
});

exports.Tags = Tags;

var Tag = _styled.default.li(function (_ref) {
  var dismissible = _ref.dismissible,
      space = _ref.theme.space;
  return _objectSpread(_objectSpread({
    display: 'inline-block',
    borderRadius: '4px',
    backgroundColor: '#ececec',
    fontSize: '12px',
    padding: '0 10px',
    marginTop: space.small,
    marginRight: space.xsmall,
    textTransform: 'capitalize'
  }, dismissible && {
    cursor: 'pointer'
  }), {}, {
    '& svg': {
      marginLeft: '2px'
    }
  });
});

exports.Tag = Tag;